export enum ProposalStatus {
  Unsent = 'UNSENT',
  Sent = 'SENT',
  Delayed = 'DELAYED',
  Won = 'WON',
  Lost = 'LOST',
  Unsigned = 'UNSIGNED',
  Awaiting_Approval = 'AWAITING_APPROVAL',
}
